import { render, staticRenderFns } from "./UpdateCourse.vue?vue&type=template&id=2a74a6c2"
import script from "./UpdateCourse.vue?vue&type=script&lang=ts"
export * from "./UpdateCourse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports